import Cookies from 'js-cookie';

export const loadState = () => {
  try {
    const serializedState = Cookies.get('userInfoData');
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(window.atob(serializedState));
  } catch (e) {
    return undefined;
  }
};

export const saveState = state => {
  try {
    const { user } = state;
    if (user.user.loggedInUser) {
      const serializedState = window.btoa(
        JSON.stringify(
          {
            userTimezone: user?.user?.loggedInUser?.data?.timezone,
          },
          null,
          0,
        ),
      );
      // SameSite=None; Secure so this cookie survives inside the athenaOne
      // cross-site iframe (PLTFM-1289); SameSite=None is only honored with Secure.
      Cookies.set('userInfoData', serializedState, { secure: true, sameSite: 'None' });
    }
  } catch (e) {
    // ignore errors
  }
};

export const emptyState = () => {
  localStorage.clear();
  Cookies.remove('userInfoData');
  Cookies.remove('p12');
  Cookies.remove('p3');
};
